import React from 'react'
import { Layout } from 'antd'
import { Route, Redirect, RouteComponentProps } from 'react-router'
import { RouteComponent } from './components'
import LayoutBase from './LayoutBase'
import setWatermark from './WaterMark'
import ModelingHeader from './components/ModelingHeader'
import User, { UserContext, IUserContext } from 'modules/User'
import AppDialog from 'components/AppDialog'
import ModelingCreateNewApp from '../modules/modeling/ModelingCreateNewApp'
import {appModule} from 'services/module'

const { Content, Header, Footer } = Layout

interface IProtectedProps extends RouteComponentProps<any> {
	user: IUser
	routeData: IRoute[]
}
export default class extends React.PureComponent<IProtectedProps> {
	refContentDiv = React.createRef<HTMLDivElement>()
	state = {
		isShowSystemList: false,
	}

	stopBubble(e: any) {
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
	}

	showSystemList = (e: any) => {
		this.setState({
			isShowSystemList: !this.state.isShowSystemList,
		})
		this.stopBubble(e)
		document.onclick = () => {
			this.setState({ isShowSystemList: false })
			document.onclick = null
		}
	}

	componentDidUpdate() {
		let { user } = this.props
		setWatermark(user.userName, this.refContentDiv.current, {
			width: 150,
			height: 150,
		})
	}

	createNewApp = () => {
		AppDialog.open(<ModelingCreateNewApp mode={2} />, {
			title: '创建应用',
			height: 320,
		})
	}

	renderLayout = ({ setModelingSystemCode }: IUserContext) => {
		let { routeData, user } = this.props
		let systemList = appModule.getSystemList()
		let currModelingSystem = appModule.getCurrentModelingSystem()
		return (
			<Layout className="app-index-layout" style={{ backgroundColor: '#edf1f5' }}>
				<Layout className="app-index-content-layout">
					<ModelingHeader routeData={routeData} changeState={this.showSystemList} />
					<Content className="modeling-content modeling-content-width">
						<ul className="system-lists" hidden={!this.state.isShowSystemList}>
							<div className="system-list">
								{systemList.map((item: SystemVo, index) => {
									return (
										<li
											key={index}
											onClick={() => {
												if (currModelingSystem.code !== item.code) {
													setModelingSystemCode(item.code)
												}
											}}
										>
											{item.name}
										</li>
									)
								})}
							</div>
							<li className="new-system-create" onClick={this.createNewApp}>
								<span>
									<i></i>创建新应用
								</span>
							</li>
						</ul>
						<div style={{ height: '100%' }} ref={this.refContentDiv}>
							{this.renderRoute()}
						</div>
					</Content>
				</Layout>
			</Layout>
		)
	}

	renderRoute = () => {
		let { routeData, user } = this.props
		return routeData.map(route => {
			let RouteContainer: any = Route
			return (
				<RouteContainer
					key={route.path}
					path={route.path}
					render={(props: any) => <RouteComponent {...props} route={route} user={user} />}
					exact={true}
					redirectPath="/exception/403"
				/>
			)
		})
	}
	render() {
		let { user } = this.props
		if (user.isLogin) {
			return (
				<LayoutBase {...this.props}>
					<UserContext.Consumer>{this.renderLayout}</UserContext.Consumer>
				</LayoutBase>
			)
		}
		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { from: this.props.location },
				}}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/layouts/ModelingLayout.tsx